import { api } from '../api/endpoints.js';
import { backButton, mainButton, haptic } from '../tg.js';
// MainButton imported only to call hide() defensively — we no longer SHOW it.

// Result — celebrates / commiserates the playthrough.
// Layout: full-bleed final unlocked image as BG, glass card with stats + actions.
// Win = stageIdx reached final (>= 4) → "HEARTBREAKER" gold treatment.
// Loss = early death → "GAME OVER" muted treatment.
export const resultScene = {
  async mount(root, ctx) {
    const r = ctx.state.result || { score: 0, bestCombo: 0, mugsCaught: 0, stageIdx: 0, pack: '', highScore: 0, newHighScore: false };
    const stagesTotal = 5;
    const won = r.stageIdx >= stagesTotal - 1;
    const finalImage = r.finalImage || null;
    const newHigh = !!r.newHighScore;

    haptic(newHigh ? 'success' : (won ? 'success' : 'warning'));

    root.innerHTML = `
      <div class="result ${won ? 'win' : 'lose'}">
        ${finalImage ? `<div class="result-bg" style="background-image:url('${finalImage}')"></div>` : '<div class="result-bg result-bg-fallback"></div>'}
        <div class="result-fade"></div>

        <div class="result-content">
          <div class="result-title-block">
            ${newHigh ? '<div class="result-newhigh">★ NEW HIGH SCORE ★</div>' : ''}
            <div class="result-tag">${won ? 'YOU UNLOCKED' : 'BETTER LUCK'}</div>
            <h1 class="result-title">${won ? 'HEARTBREAKER' : 'GAME OVER'}</h1>
            ${r.pack ? `<div class="result-pack">${r.pack}</div>` : ''}
          </div>

          <div class="result-stats">
            <div class="result-stat">
              <div class="stat-v neon-white">${r.score.toLocaleString()}</div>
              <div class="stat-l">SCORE</div>
            </div>
            <div class="result-stat">
              <div class="stat-v neon-pink">×${r.bestCombo}</div>
              <div class="stat-l">HOTTEST COMBO</div>
            </div>
            <div class="result-stat">
              <div class="stat-v neon-blue">${r.mugsCaught}</div>
              <div class="stat-l">MUGS</div>
            </div>
            <div class="result-stat">
              <div class="stat-v neon-gold">${(r.stageIdx ?? 0) + 1}/${stagesTotal}</div>
              <div class="stat-l">STAGE</div>
            </div>
          </div>

          <div class="result-actions">
            <button class="btn-primary" id="btn-restart">PLAY AGAIN</button>
            <button class="btn-ghost" id="btn-menu">BACK TO MENU</button>
          </div>
        </div>
      </div>`;

    // Refresh balance silently for next menu visit.
    try { ctx.state.user = await api.getMe(); } catch {}

    const goPacks = () => { haptic('medium'); ctx.goto('packs'); };
    const goMenu  = () => { haptic('light');  ctx.goto('menu'); };

    root.querySelector('#btn-restart').onclick = goPacks;
    root.querySelector('#btn-menu').onclick = goMenu;

    // Native: keep BackButton (top-left Telegram chrome) but NO MainButton.
    mainButton.hide();
    this._offBack = backButton.show(goMenu);
  },

  async destroy() {
    this._offBack?.();
  }
};
